import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import RedWarningIcon from "../../../assets/icons/red-warning-with-bg.svg";
import FreeSubscriptionInfoModal from "../modals/FreeSubscriptionInfoModal";
import "./index.less";

const FreeSubscriptionWarning: React.FC = () => {
  const { t } = useTranslation();
  const [showInfoModal, setShowInfoModal] = useState<boolean>(false);

  return (
    <>
      <div className="free-subscription-warning-container">
        <div className="free-subscription-warning-content">
          <img src={RedWarningIcon} className="free-subscription-warning-icon" alt="Warning" />
          <div className="free-subscription-warning-text-container">
            <div className="free-subscription-warning-title">{t("free-subscription-warning-title")}</div>
            <div className="free-subscription-warning-description">{t("free-subscription-warning-description")}</div>
          </div>
        </div>
        <button className="free-subscription-warning-button" onClick={() => setShowInfoModal(true)}>
          {t("more-info")}
        </button>
      </div>
      {showInfoModal && <FreeSubscriptionInfoModal onClose={() => setShowInfoModal(false)} />}
    </>
  );
};

export default FreeSubscriptionWarning;
